import { render, staticRenderFns } from "./AnketInfo.vue?vue&type=template&id=3c2e7d74&scoped=true"
import script from "./AnketInfo.vue?vue&type=script&lang=js"
export * from "./AnketInfo.vue?vue&type=script&lang=js"
import style0 from "./AnketInfo.vue?vue&type=style&index=0&id=3c2e7d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e7d74",
  null
  
)

export default component.exports